import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useProductPrintTagsDict = () => {
    const { t } = useTwinTranslation()
    const dictCreateType: TwinDictionary = {
        'allProducts': { name: t('withAllProducts', 'Con todos los productos') },
        'onlyMain': { name: t('onlyMainProducts', 'Solo productos principales') },
        'onlyVariants': { name: t('onlyVariants', 'Solo variantes') },
    }
    return dictCreateType
}

export default useProductPrintTagsDict